import { useCallback } from 'react';

import { useDispatch } from 'react-redux';

import scrollTo from 'src/redux/global/actions/scroll-to';
import urls from 'src/redux/pull-request/urls';
import authRequest from 'src/utils/fetch';

import { FIX_MISSING_COMMITS, refreshCodeReviewData } from '../actions';

export function useFixMissingCommits() {
  const dispatch = useDispatch();

  const fixMissingCommits = useCallback(
    async ({ owner, slug, id }: any) => {
      dispatch({
        type: FIX_MISSING_COMMITS.REQUEST,
      });

      const url = urls.api.internal.updatePullRequestSourceBranch(
        owner,
        slug,
        id!
      );
      try {
        const authUrl = authRequest(url, { method: 'POST' });
        const response = await fetch(authUrl);
        if (!response.ok) {
          throw Error('Error updating the pull request source branch');
        }

        dispatch(
          refreshCodeReviewData({
            needsDiff: true,
            needsPullRequest: true,
            needsComments: true,
            needsTasks: false,
          })
        );

        dispatch({
          type: FIX_MISSING_COMMITS.SUCCESS,
        });

        dispatch(
          scrollTo({
            targetId: 'root',
          })
        );
      } catch {
        dispatch({
          type: FIX_MISSING_COMMITS.ERROR,
        });
      }
    },
    [dispatch]
  );

  return fixMissingCommits;
}
